import React from 'react';
import { Container, Col, Row, ListGroup, Button, Modal, ButtonGroup } from 'react-bootstrap';
import { FaPen, FaPlus, FaTrash } from 'react-icons/fa';

import { IntrashBackend } from './backend';

import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';


export class UsersPage extends React.Component {
    constructor(props) {
        super(props);
  
        this.state = {
            users: [],
            showErrorModal: false,
            errorModalText: "",
            userToDelete: null,
            showDeleteConfirmationModal: false,
            deleteConfirmationModalUsername: ""
        };

        IntrashBackend.getUsers().then((u) => this.setState({ users: u }));
    }

    refreshUsers() {
        IntrashBackend.getUsers().then((u) => this.setState({ users: u }));
    }

    async addUser(e) {
        this.props.onAddUser();
        e.preventDefault();
    }

    async editUser(e, user) {
        this.props.onEditUser(user);
        e.preventDefault();
    }

    async askDeleteUser(e, user) {
        this.setState({ userToDelete: user, showDeleteConfirmationModal: true, deleteConfirmationModalUsername: user.username });
        e.preventDefault();
    }

    async doDeleteUser(e) {
        try {
            await IntrashBackend.deleteUser(this.state.userToDelete.id);
            this.setState({ userToDelete: null, showDeleteConfirmationModal: false });
            this.refreshUsers();
        }
        catch (exc) {
            this.setState({ userToDelete: null, showDeleteConfirmationModal: false, showErrorModal: true, errorModalText: "An error occurred: " + exc });
        }
        e.preventDefault();
    }

    mapUserToListItem = (user) => {
        return (
            <ListGroup.Item style={{ overflow: "hidden" }} key={user.id}>
                <Row className="my-auto">
                    <Col className="my-auto text-left" as="h5">
                        {user.username}
                    </Col>
                    <Col xs="auto" md="auto">
                        <ButtonGroup xs="auto" md="auto">
                            <Button variant="link" onClick={(e) => this.editUser(e, user)}><FaPen color="darkslategray"/></Button>
                            <Button variant="link" onClick={(e) => this.askDeleteUser(e, user)}><FaTrash color="red"/></Button>
                        </ButtonGroup>
                    </Col>
                </Row>
            </ListGroup.Item>
        );
    }
    
    renderUsersList = () => {
        if (this.state.users) {
            this.state.users.sort((a, b) => b.username.toUpperCase() < a.username.toUpperCase() ? 1 : -1);
            return (
                <>
                    <ListGroup>
                        {this.state.users.map(this.mapUserToListItem)}
                    </ListGroup>
                    <Modal show={this.state.showDeleteConfirmationModal} onHide={() => this.setState({ showDeleteConfirmationModal: false })}>
                        <Modal.Header closeButton>
                            <Modal.Title>Delete User</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>Delete user '{this.state.deleteConfirmationModalUsername}'?</Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={() => this.setState({ showDeleteConfirmationModal: false })}>
                                Cancel
                            </Button>
                            <Button variant="danger" onClick={(e) => this.doDeleteUser(e)}>
                                Delete
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </>
            );
        }
    }

    render() {
        return (
            <>
                <Container fluid>
                    <Row><Col><h3 className="text-center">Users</h3></Col></Row>
                    <br/>
                    <Row><Col><Button variant="outline-primary" block onClick={(e) => this.addUser(e)}><FaPlus/></Button></Col></Row>
                    <br/>
                    {this.renderUsersList()}
                </Container>
                <Modal show={this.state.showErrorModal} onHide={() => this.setState({ showErrorModal: false })}>
                    <Modal.Header closeButton>
                        <Modal.Title>Error</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>{this.state.errorModalText}</Modal.Body>
                    <Modal.Footer>
                        <Button onClick={() => this.setState({ showErrorModal: false })}>
                            OK
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}